import EventEmitter from 'eventemitter3';
import { parseUrl } from '../utils/common';

class Base extends EventEmitter {
  constructor(options, gameData) {
    super();
    this.options = options;
    this.gameData = gameData;
  }

  _getThumbnail(options, gameData) {
    let thumbnail = gameData.assets.find(
      (asset) => asset.hasOwnProperty('name') && asset.width === 512 && asset.height === 512,
    );
    if (!thumbnail && gameData.assets.length > 0) thumbnail = gameData.assets[0];
    if (thumbnail) thumbnail = `${thumbnail.name}`;
    thumbnail = parseUrl(options.imgHost, thumbnail);
    return thumbnail;
  }
  _registerEvents() {
    const playButton = document.getElementById(`${this.options.prefix}splash-button`);
    if (playButton)
      playButton.addEventListener('click', (event) => {
        this.emit('playClick', event);
      });

    const container = document.getElementById(`${this.options.prefix}splash`);
    if (container)
      container.addEventListener('click', (event) => {
        this.emit('containerClick', event);
      });
  }

  hide() {
    const container = this._container;
    const extContainer = this._extContainer;

    if (container && container.parentNode) container.parentNode.removeChild(container);
    if (extContainer) extContainer.style.display = 'none';
  }

  _insertCss(css) {
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    const existingStyle = document.head.querySelector('style[data-g8-splash-style]');
    if (existingStyle) existingStyle.remove();

    style.type = 'text/css';
    style.setAttribute('data-g8-splash-style', true);

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
    head.appendChild(style);
  }
  _getExtContainer() {
    if (!this.options.flashSettings.splashContainerId) return;
    return document.getElementById(this.options.flashSettings.splashContainerId);
  }
  getRoot() {
    return this._root;
  }
}

export default Base;
